export const getDeferredImageUrl = (state, imageEntitlementToken) => {
  return state.deferredImages.deferredImages[imageEntitlementToken]
}
